import React from 'react'
//import { useSelector } from 'react-redux';
import {Navigate,Outlet} from 'react-router-dom';
import commonUtility from './Utils';



const ProtectedRoute = ({children}) => {
  let isUserLoggedIn = false;

  //console.log('commonUtility',commonUtility.isLoggedIn());  
  
  //console.log('getLoggedInUserInfo', commonUtility.isTokenExpired() ? " Expired " : "Alive ");
  
  if(commonUtility.isLoggedIn() && !commonUtility.isTokenExpired()){
    isUserLoggedIn = true;
  }

  /*
  const isLoggedIn = false;
  const userLoggedIn = localStorage.getItem("user");
  const userLoggedIn = true;
  */
 // const { isAuth } = useSelector(state => state.login);
  //console.log("isAuth" + isAuth);
  if (!isUserLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  else{

   
    return children ? children : <Outlet />;
  }
  
}
export default ProtectedRoute